export default [
    {
        path: '',
        name: 'pageBudayaIndex',
        component: () => import('./page-budaya')
    }
]